import React from "react";
import { jsPDF } from "jspdf";

function generateAndPrintPDF() {
    // Create a new PDF document
    const doc = new jsPDF();

    // Add some content
    doc.setFont("helvetica", "bold");
    doc.text("Hello, this is your PDF!", 20, 20);

    // Save or print
    const pdfBlob = doc.output("blob");
    const url = URL.createObjectURL(pdfBlob);

    // Open in a new tab (optional)
    // window.open(url);

    // Print directly
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    iframe.src = url;
    iframe.onload = () => {
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
    };
}


const GeneratePDF = () => {
  const handlePrint = () => {
    // Call the function to generate and print the PDF
    generateAndPrintPDF();
  };

  return (
    <div>
      <button onClick={handlePrint}>Generate & Print PDF</button>
    </div>
  );
};

export default GeneratePDF;
